module.exports = __webpack_public_path__ + "images/7b9163530a290eb4bd644723281288f2.svg";